module.exports = __webpack_public_path__ + "assets/img/lector-2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lectors/lector-2.jpg
// module id = 1957
// module chunks = 0